export default "__VITE_ASSET__BXN8KLQY__"